<form [formGroup]="customerAddressForm" *transloco="let t">
	<beyond-online-text-input
		[attr.data-invalid]="customerAddressForm.controls.firstLineName.invalid"
		[error]="getError(customerAddressForm.controls.firstLineName, 'firstLineName')"
	>
		<input data-test-id="firstName" formControlName="firstLineName" type="text" beyondInput />
		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.firstName.label')
		}}</label>
	</beyond-online-text-input>

	<vis-ods-auto-complete-component
		[label]="
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.country.label')
		"
		formControlName="countryCode"
		[items]="$formattedCountryCodes() | sortBy: 'displayValue'"
		[editableSearchTerm]="true"
		[searchFn]="searchFn"
		[notFoundText]="
			t(
				'generalComponents.addressSelector.subComponents.customerAddress.inputs.country.errors.notFound'
			)
		"
	>
		<vis-ods-icon-component
			endIcon
			name="odsSearch"
			width="16"
			height="16"
			class="text-body"
		></vis-ods-icon-component>
	</vis-ods-auto-complete-component>

	<div class="my-s">
		<vis-ods-address-autosuggest-component
			[notFoundText]="
				t(
					'generalComponents.addressSelector.subComponents.customerAddress.inputs.autosuggest.errors.addressNotFound'
				)
			"
			#autoSuggest
			[userLanguage]="userLanguage"
			[inputLabel]="
				t(
					'generalComponents.addressSelector.subComponents.customerAddress.inputs.autosuggest.label'
				)
			"
			[countriesToBeSearched]="[customerAddressForm.controls.countryCode.value || '']"
			[formControl]="addressSuggestControl"
			(addressSelected)="onAddressSelected($event)"
		>
		</vis-ods-address-autosuggest-component>
	</div>

	<beyond-online-text-input
		[attr.data-invalid]="customerAddressForm.controls.street.invalid"
		[error]="getError(customerAddressForm.controls.street, 'street')"
	>
		<input formControlName="street" type="text" beyondInput #street />
		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.street.label')
		}}</label>
	</beyond-online-text-input>
	<beyond-online-text-input
		[attr.data-invalid]="customerAddressForm.controls.houseNumber.invalid"
		[error]="getError(customerAddressForm.controls.houseNumber, 'houseNumber')"
	>
		<input formControlName="houseNumber" type="text" beyondInput #houseNumber />
		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.streetNumber.label')
		}}</label>
	</beyond-online-text-input>
	<beyond-online-text-input
		[attr.data-invalid]="customerAddressForm.controls.zipCode.invalid"
		[error]="getError(customerAddressForm.controls.zipCode, 'zipCode')"
	>
		<input formControlName="zipCode" type="text" beyondInput #zipCode />
		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.zipCode.label')
		}}</label>
	</beyond-online-text-input>
	<beyond-online-text-input
		[attr.data-invalid]="customerAddressForm.controls.city.invalid"
		[error]="getError(customerAddressForm.controls.city, 'city')"
	>
		<input formControlName="city" type="text" beyondInput #city />
		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.city.label')
		}}</label>
	</beyond-online-text-input>
	<beyond-online-text-input>
		<input formControlName="state" type="text" beyondInput />
		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.state.label')
		}}</label>
	</beyond-online-text-input>
	<beyond-online-text-input>
		<input formControlName="floor" type="text" beyondInput />
		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.floor.label')
		}}</label>
	</beyond-online-text-input>

	<beyond-online-text-input>
		<input formControlName="room" type="text" beyondInput />
		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.room.label')
		}}</label>
	</beyond-online-text-input>

	<beyond-online-text-input>
		<input formControlName="postBox" type="text" beyondInput />
		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.postBox.label')
		}}</label>
	</beyond-online-text-input>

	<div class="font-bold mt-l mb-xs">
		{{ t('generalComponents.addressSelector.subComponents.customerAddress.texts.howToContact') }}
	</div>
	<beyond-online-text-input
		[attr.data-invalid]="customerAddressForm.controls.email.invalid"
		[error]="getError(customerAddressForm.controls.email, 'email')"
		[helperText]="
			t(
				'generalComponents.addressSelector.subComponents.customerAddress.inputs.email.helperTexts.mail'
			)
		"
	>
		<input formControlName="email" type="email" beyondInput #email />
		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.email.label')
		}}</label>
	</beyond-online-text-input>

	<vis-ods-auto-complete-component
		[label]="
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.phonePrefix.label')
		"
		formControlName="phonePrefix"
		[items]="$formattedCountryPhoneCodes()"
		[editableSearchTerm]="true"
		[searchFn]="searchFn"
		[compareFn]="comparePhonePrefixFn"
		[notFoundText]="
			t(
				'generalComponents.addressSelector.subComponents.customerAddress.inputs.phonePrefix.errors.notFound'
			)
		"
	></vis-ods-auto-complete-component>

	<beyond-online-text-input
		[attr.data-invalid]="customerAddressForm.controls.phone.invalid"
		[error]="getError(customerAddressForm.controls.phone, 'phone')"
		[helperText]="
			t(
				'generalComponents.addressSelector.subComponents.customerAddress.inputs.phone.helperTexts.phone'
			)
		"
	>
		<input #phone formControlName="phone" type="text" beyondInput />

		<label>{{
			t('generalComponents.addressSelector.subComponents.customerAddress.inputs.phone.label')
		}}</label>
	</beyond-online-text-input>

	<button
		beyond-online-button
		(click)="onAccept()"
		[loading]="$isValidating()"
		class="w-full mt-l mb-s justify-center"
		variant="primary"
		[label]="t('generalComponents.addressSelector.subComponents.customerAddress.buttons.accept')"
	></button>
	<button
		beyond-online-button
		class="w-full justify-center"
		variant="secondary"
		[disabled]="$isValidating()"
		(click)="onCancel()"
		[label]="t('generalComponents.addressSelector.subComponents.customerAddress.buttons.cancel')"
	></button>
</form>
